import * as Yup from 'yup';

const placeAddressLinkSchema = Yup.object({
  ptsAddressID: Yup.number().nullable().required('An address must be selected'),
});

export default placeAddressLinkSchema;
